import React, { FC, useMemo, useState } from "react";
import ModalPortal from "components-new/ModalPortal";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import Textarea from "components-new/Textarea";
import InputTemp from "components-new/InputTemp";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { useValidate } from "hooks/useValidate";
import { addCode } from "toolkit/codes/codes.thunks";
import { setAddingModal } from "toolkit/codes/codes.slice";
import styles from "./AddingCode.module.sass";

interface AddingCodeProps {
	close: () => void;
}

const AddingCode: FC<AddingCodeProps> = ({ close }) => {
	const dispatch = useAppDispatch();

	const { sections, modals } = useAppSelector((state) => state.codes);

	const [errors] = useState<any[]>([]);

	const options = useMemo(() => {
		return sections.map((section, index) => ({ ...section, id: index + 1 }));
	}, [sections]);

	const { error, validate } = useValidate(modals.addingCodeModal.values, ["code", "name", "sectionCode"], () => {
		dispatch(addCode(modals.addingCodeModal.values)).then(() => close());
	});

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		dispatch(
			setAddingModal({
				visible: modals.addingCodeModal.visible,
				inputValues: { ...modals.addingCodeModal.values, [name]: value },
			}),
		);
	};
	return (
		<ModalPortal title="Добавление кода ОКВЭД" handleClose={close} outSide={false}>
			<div className={styles.content}>
				<InputTemp
					required
					filter
					emptyOptions={false}
					name="sectionCode"
					isCreated
					label={"Выберите раздел"}
					value={modals.addingCodeModal.values.sectionCode}
					onSelect={(e) => {
						dispatch(
							dispatch(
								setAddingModal({
									visible: modals.addingCodeModal.visible,
									inputValues: {
										...modals.addingCodeModal.values,
										sectionCode: e.code,
									},
								}),
							),
						);
					}}
					onChange={changeHandler}
					options={options}
					field="code"
					error={error && !modals.addingCodeModal.values.sectionCode}
				/>
				<InputTemp
					required
					name="code"
					label="Код группы и рода деятельности"
					value={modals.addingCodeModal.values.code}
					onChange={changeHandler}
					error={error && !modals.addingCodeModal.values.code}
					errorText={errors.includes("code") ? "Код должен быть уникальным" : ""}
				/>
				<Textarea
					rows={1}
					name="name"
					autosize={true}
					required
					label="Наименование рода деятельности"
					value={modals.addingCodeModal.values.name}
					onChange={changeHandler}
					error={error && !modals.addingCodeModal.values.name}
				/>
				<Textarea
					rows={1}
					name="description"
					autosize={true}
					label="Описание"
					value={modals.addingCodeModal.values.description}
					onChange={changeHandler}
				/>
			</div>

			<div className="df">
				<Button className={styles.button} full variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button className={styles.button} full onClick={validate}>
					Готово
				</Button>
			</div>
		</ModalPortal>
	);
};

export default AddingCode;
